import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.css';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import cn from 'classnames';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const FloatingActionButton = ({ actions, className }) => {
  const [isOpen, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('touchend', handleClickOutside);
    return () => {
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, [wrapperRef]);

  const toggle = (
    <A11y>
      {isOpen ? (
        <div
          /* eslint-disable jsx-a11y/tabindex-no-positive */
          tabIndex="1"
          onClick={() => setOpen(false)}
          aria-label="Close"
          aria-expanded={isOpen}
          className={cn(styles.fabItem, styles.fabToggle, styles.open)}
          role="button"
        >
          <Icon id="close" width="14" height="14" className="text-white" />
        </div>
      ) : (
        <div
          /* eslint-disable jsx-a11y/tabindex-no-positive */
          tabIndex="1"
          aria-label="Open"
          onClick={() => setOpen(true)}
          aria-expanded={isOpen}
          className={cn(styles.fabItem, styles.fabToggle)}
          role="button"
        >
          <Icon id="three_dots" />
        </div>
      )}
    </A11y>
  );

  return (
    <div ref={wrapperRef}>
      <div className={cn(styles.fabContainer, className)}>
        {isOpen &&
          actions.map((action, index) => (
            <A11y key={index}>
              <div
                role="button"
                aria-label={action.ariaLabel}
                tabIndex={0}
                className={styles.fabItem}
                onClick={(e) => action.onClick(e, setOpen)}
              >
                {action.icon}
              </div>
            </A11y>
          ))}
        {toggle}
      </div>
    </div>
  );
};
export default FloatingActionButton;
